import React, { useEffect, useState } from "react";
import Axios from "axios";
import ActionButtons from "../../components/ActionButtons";
import { storageRongve, firestoreRongve } from "../../firebase";
import { FaBell, FaUsers, FaHeading, FaFileAlt } from 'react-icons/fa';
import { styles } from './Styles';

const chunkArray = (array, size) => {
  const chunks = [];
  for (let i = 0; i < array.length; i += size) {
    chunks.push(array.slice(i, i + size));
  }
  return chunks;
};

const otherCategories = ["Trener", "Forelder", "Spiller"];

export default function RongvePushNotifications(props) {
  const [users, setUsers] = useState([]);
  const [alerts, setAlerts] = useState([]);
  const [selectedClubs, setSelectedClubs] = useState([]);
  const [clubs, setClubs] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [batchLogs, setBatchLogs] = useState([]);
  const [sendingComplete, setSendingComplete] = useState(false);

  const getUsers = async () => {
    const usersRef = firestoreRongve.collection("users");
    const snapshot = await usersRef.get();
    const userList = [];
    snapshot.forEach((doc) => {
      const userData = doc.data();
      userList.push({ id: doc.id, ...userData });
    });
    setUsers(userList);
  };

  const getClubInfo = async () => {
    const logoRef = storageRongve.ref("clubLogos/");
    const newClubs = [];
    const res = await logoRef.listAll();
    await Promise.all(
      res.items.map(async (itemRef) => {
        newClubs.push(itemRef.name);
      })
    );

    newClubs.forEach((club, index) => {
      newClubs[index] = club.slice(0, -4);
    });

    setClubs(newClubs);
  };
  const isSelected = (item) => selectedClubs.includes(item) || (selectAll && item !== "Alle");

  const handleClubSelection = (club) => {
    if (selectedClubs.includes(club)) {
      setSelectedClubs(selectedClubs.filter((id) => id !== club));
    } else {
      setSelectedClubs([...selectedClubs, club]);
    }
  };

  const handleSelectAll = () => {
    if (!selectAll) {
      setSelectedClubs([...clubs, ...otherCategories]);
      setSelectAll(true);
      setSelectedClubs((prev) => [...prev, "Alle"]);
      const checkboxes = document.querySelectorAll(
        'input[type="checkbox"]:not(#selectAll)'
      );
      checkboxes.forEach((checkbox) => {
        checkbox.checked = false;
      });
    } else {
      setSelectedClubs([]);
      setSelectAll(false);
    }
  };

  const handlePushNotification = async () => {
    let pushTokens = [];
    const title = document.getElementById("title").value;
    const body = document.getElementById("body").value;

    setBatchLogs([]);
    setSendingComplete(false);

    users.forEach((user) => {
      if (user.expoPushToken && user.expoPushToken.length > 0) {
        const userClubIds = (user.clubIds || []).map((id) =>
          id.replace(".png", "")
        );

        const isForEveryone = selectedClubs.includes("Alle");

        const relevantClubs = userClubIds.filter((club) =>
          selectedClubs.includes(club)
        );
        const hasClub = relevantClubs.length > 0;
        const isOnlyRolesNews =
          selectedClubs.includes(user.userType) &&
          !selectedClubs.some((c) => clubs.includes(c));
        const isGeneralRoleNews =
          selectedClubs.includes(user.userType) && selectedClubs.length === 1;
        const isRoleAndClubNews =
          hasClub && selectedClubs.includes(user.userType);
        const isGeneralClubNews = hasClub && selectedClubs.length === 1;
        const isTrainerNews =
          user.trainer &&
          selectedClubs.includes("Trener") &&
          (hasClub || selectedClubs.length === 1);

        if (
          isForEveryone ||
          isGeneralRoleNews ||
          isRoleAndClubNews ||
          isOnlyRolesNews ||
          isGeneralClubNews ||
          isTrainerNews
        ) {
          pushTokens.push(user.expoPushToken);
        }
      }
    });

    pushTokens = Array.from(new Set(pushTokens));
    
    if (title && body && selectedClubs.length > 0) {
      setAlerts([...alerts, { title }]);

      const tokenChunks = chunkArray(pushTokens, 100);
      let successCount = 0;
      
      try {
        for (let i = 0; i < tokenChunks.length; i++) {
          const chunk = tokenChunks[i];
          const tokensBatch = JSON.stringify(chunk);
          
          try {
            await Axios.post(
              `https://webnow-adminpanel.ew.r.appspot.com/send?pushTokens=${tokensBatch}&title=${title}&body=${body}&useFcmV1=true`
            );
            successCount++;
            setBatchLogs(prev => [...prev, {
              batchNumber: i + 1,
              success: true,
              message: `Batch ${i + 1}: Sendt til ${chunk.length} tokens`
            }]);
          } catch (error) {
            setBatchLogs(prev => [...prev, {
              batchNumber: i + 1,
              success: false,
              message: `Feil i batch ${i + 1}: ${error.message}`
            }]);
          }
        }
      } finally {
        setSendingComplete(true);
        setBatchLogs(prev => [...prev, {
          batchNumber: tokenChunks.length + 1,
          summary: true,
          message: `Alle ${tokenChunks.length} batches forsøkt sendt. ${successCount} av ${tokenChunks.length} vellykkede.`
        }]);
      }
    }
  };

  const BatchLogs = () => {
    const logStyle = {
      marginTop: '20px',
      padding: '10px',
      backgroundColor: '#000',
      borderRadius: '5px'
    };

    const logLineStyle = {
      margin: '5px 0',
      fontFamily: 'monospace'
    };

    return batchLogs.length > 0 ? (
      <div style={logStyle}>
        {batchLogs.map((log, index) => (
          <div key={index} style={logLineStyle}>
            {log.summary ? (
              <strong>{log.message}</strong>
            ) : (
              <>
                {log.success ? '✅' : '❌'} {log.message}
              </>
            )}
          </div>
        ))}
      </div>
    ) : null;
  };

  useEffect(() => {
    getUsers();
    getClubInfo();
  }, []);

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>
        <FaBell style={styles.headerIcon} /> Send push notifikasjon
      </h2>
      <form>
        <div style={styles.inputGroup}>
          <FaHeading style={styles.inputIcon} />
          <input
            type="text"
            style={styles.input}
            id="title"
            placeholder="Tittel"
          />
        </div>
        
        <div style={styles.inputGroup}>
          <FaFileAlt style={styles.inputIcon} />
          <input
            type="text"
            style={styles.input}
            id="body"
            placeholder="Innhold"
          />
        </div>
        
        <div style={styles.categorySection}>
          <h3 style={styles.categoryHeader}>
            <FaUsers style={styles.categoryIcon} /> Velg målgrupper
          </h3>
          <div style={styles.selectionContainer}>
            <div 
              style={{
                ...styles.selectionBox,
                ...(selectAll ? styles.selectedBox : {})
              }}
              onClick={handleSelectAll}
            >
              Alle
            </div>
          </div>
          
          <h4 style={styles.subCategoryHeader}>Velg kategorier:</h4>
          <div style={styles.selectionContainer}>
            {otherCategories.map((category) => (
              <div 
                key={category}
                style={{
                  ...styles.selectionBox,
                  ...(isSelected(category) ? styles.selectedBox : {})
                }}
                onClick={() => handleClubSelection(category)}
              >
                {category}
              </div>
            ))}
          </div>
          
          <h4 style={styles.subCategoryHeader}>Velg klubber:</h4>
          <div style={styles.selectionContainer}>
            {clubs.map((club) => (
              <div 
                key={club}
                style={{
                  ...styles.selectionBox,
                  ...(isSelected(club) ? styles.selectedBox : {})
                }}
                onClick={() => handleClubSelection(club)}
              >
                {club}
              </div>
            ))}
          </div>
        </div>
        
        <ActionButtons
          setActive={props.setActive}
          onClick={handlePushNotification}
        />
      </form>
      
      {alerts.length > 0 &&
        alerts.map((alert, index) => (
          <div key={index} style={styles.alert}>
            Push notifikasjon med tittel <b>{alert.title}</b> sendt ut. Kan ta
            opptil 20 minutter før den vises.
          </div>
        ))}
      
      <BatchLogs />
    </div>
  );
}